import React from 'react';
import PersonCard from './PersonCard';

const SECTIONS = [
  { key: 'one_class', label: '1 Class Completed', className: 'one-class', emptyText: 'No one with 1 class this month' },
  { key: 'two_classes', label: '2 Classes Completed', className: 'two-classes', emptyText: 'No one with 2 classes this month' },
  { key: 'three_classes', label: '3 Classes Completed', className: 'three-classes', emptyText: 'No one with 3 classes this month' },
];

function PeopleBoard({ data, onPersonClick }) {
  const { sections } = data;
  return (
    <div className="board">
      {SECTIONS.map((section) => {
        const people = sections[section.key] || [];
        return (
          <div className="section" key={section.key}>
            <div className="section-header">
              <span className={`section-tag ${section.className}`}>{section.label}</span>
              <span className="section-count">{people.length} {people.length === 1 ? 'person' : 'people'}</span>
            </div>
            <div className="section-divider" />
            {people.length > 0 ? (
              <div className="people-grid">
                {people.map((person) => (
                  <PersonCard key={person.id} person={person} sectionClass={section.className} onClick={() => onPersonClick(person)} />
                ))}
              </div>
            ) : (
              <div className="people-grid empty">
                <span className="empty-message">{section.emptyText}</span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default PeopleBoard;
